<template>
  <div class="container">
    <div class="row">
      <div class="col 2-col">
        <h2 id="references">References</h2>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable */
    import ImageMap from '@/components/factsheet/maps/ImageMap.vue'

    import _ from 'lodash';

    export default {
        name: 'References',
        components: { ImageMap },
        props: ['location', 'factsheet', 'loaded'],
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        filters: {
          percent: function (value) {
            return value.toFixed(1)+'%'
          }
        },
        methods: {
          urlFor(asset) {
            return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+asset;
          },
          andList(list, attr, attrpercent) {
            var ret = ""
            for(var i=0; i<list.length;i++) {
              var percent = attrpercent ? ' ('+list[i][attrpercent]+'%)' : ''
              if (list.length == 1) {
                return list[i][attr]+percent
              }
              if(i == list.length-1) {
                ret += " and "+list[i][attr]+percent
              } else {
                ret += list[i][attr]+percent+", "
              }
            }
            return ret
          }
        }
    }
</script>

<style>
div.map {
    width:100%;
    height:450px;
    display:block;
}
</style>

<style scoped>

caption {
  caption-side: top;
  font-weight:bold;
  font-size:1em;
  padding:5px;
  color:rgb(33, 37, 41);
  padding-left:0px;
}
table {
   font-size:0.75em;
}
table th, table td {
  padding-left:0px;
}

</style>